import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=322c77fa&"
import script from "./AddOns.vue?vue&type=script&lang=js&"
export * from "./AddOns.vue?vue&type=script&lang=js&"
import style0 from "./AddOns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports